<template>
    <table
        class="table"
        :class="{ 'table--rounded-theme': theme === 'rounded' }"
    >
        <thead>
            <tr>
                <th
                    v-for="(field, index) in fields"
                    :key="index"
                >
                    <router-link
                        v-if="columnsLink[index]"
                        class="link link--black link--underline"
                        :to="columnsLink[index]"
                    >
                        {{ field }}
                    </router-link>
                    <span v-else>{{ field }}</span>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr
                v-for="(item, index) in tableData"
                :key="index"
            >
                <td
                    v-for="field in fields"
                    :key="item[field]"
                    v-html="item[field]"
                />
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: 'Table',
    props: {
        tableData: {
            required: true,
            type: Array,
        },
        theme: {
            type: String,
            default: 'default',
            validator(value) {
                return ['default', 'rounded'].includes(value);
            },
        },
        columnsLink: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        fields() {
            return Object.keys(this.tableData[0]);
        },
    },
};
</script>
<style lang="scss" src="./style.scss"></style>
